import { State, Action, StateContext, Selector, NgxsOnInit } from "@ngxs/store";
import { UI } from "../interface/ui";
import { Platform } from "@angular/cdk/platform";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SwUpdate } from "@angular/service-worker";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { calculateWidth } from "../helpers/helpers";
import { NewVersionComponent } from "../new-version/new-version.component";

let win: any;

export class ToggleCellarView {
  static readonly type = "[UI] ToggleCellarView]";
}

export class ToggleInventoryView {
  static readonly type = "[UI] ToggleInventoryView]";
}

export class ToggleProductView {
  static readonly type = "[UI] ToggleProductView]";
}

export class SelectedColor {
  static readonly type = "[UI] SelectedColor]";
  constructor(public readonly color: string) {}
}

export class SetDrawer {
  static readonly type = "[UI] SetDrawer]";
  constructor(public readonly drawer: any) {}
}

export class InstallApp {
  static readonly type = "[UI] InstallApp]";
}

export class Loader {
  static readonly type = "[UI] Loader]";
  constructor(public readonly LoaderState: number) {}
}

export class VerifyInstallPrompt {
  static readonly type = "[UI] VerifyInstallPrompt]";
}

export class Vibrate {
  static readonly type = "[UI] Vibrate]";
  constructor(public readonly duration: number) {}
}

@State<UI>({
  name: "ui",
  defaults: {
    cellar: {
      list: false,
    },
    inventory: {
      list: false,
    },
    product: {
      list: false,
    },
  },
})
@Injectable()
export class UIState implements NgxsOnInit {
  window: any;
  private isSubscribed = false;

  @Selector()
  static device({ device }: UI) {
    return device;
  }

  @Selector()
  static selectedColor({ selectedColor }: UI) {
    return selectedColor;
  }

  @Selector()
  static product({ product: { list } }: UI) {
    return list;
  }

  @Selector()
  static inventory({ inventory: { list } }: UI) {
    return list;
  }

  @Selector()
  static cellar({ cellar: { list } }: UI) {
    return list;
  }

  @Selector()
  static install({ install }: UI) {
    return install;
  }

  @Selector()
  static share({ share }: UI) {
    return share;
  }

  @Selector()
  static LoaderState({ LoaderState }: UI) {
    return LoaderState;
  }

  constructor(
    public platform: Platform,
    private swUpdate: SwUpdate,
    private dialog: MatDialog
  ) {}

  ngxsOnInit(ctx: StateContext<UI>) {
    if (!this.isSubscribed) {
      this.isSubscribed = true;

      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === "VERSION_READY") {
          this.dialog
            .open(NewVersionComponent, {
              disableClose: true,
              maxWidth: calculateWidth(),
              width: calculateWidth(),
            })
            .afterClosed()
            .subscribe((result) => {
              if (result) {
                this.swUpdate
                  .activateUpdate()
                  .then(() => window.location.reload());
              }
            });
        }
      });
    }

    ctx.dispatch(new VerifyInstallPrompt());
  }

  @Action(VerifyInstallPrompt)
  verifyInstallPrompt({ patchState }: StateContext<UI>) {
    win = window.navigator;
    let share = false;
    if (win.share) {
      share = true;
    }
    window.addEventListener("beforeinstallprompt", (install: any) => {
      install.preventDefault();
      patchState({ install });
    });
    const { userAgent, platform } = navigator;
    patchState({
      device: { ...this.platform, userAgent, name: platform },
      share,
    });
  }

  @Action(ToggleCellarView)
  toggleCellarView({ patchState, getState }: StateContext<UI>) {
    const {
      cellar: { list },
    } = getState();
    patchState({ cellar: { list: !list } });
  }

  @Action(ToggleInventoryView)
  toggleInventoryView({ patchState, getState }: StateContext<UI>) {
    const {
      inventory: { list },
    } = getState();
    patchState({ inventory: { list: !list } });
  }

  @Action(ToggleProductView)
  toggleProductView({ patchState, getState }: StateContext<UI>) {
    const {
      product: { list },
    } = getState();
    patchState({ product: { list: !list } });
  }

  @Action(SelectedColor)
  SelectedColor({ patchState }: StateContext<UI>, { color }: SelectedColor) {
    patchState({ selectedColor: color });
  }

  @Action(SetDrawer)
  SetDrawer({ patchState }: StateContext<UI>, { drawer }: SetDrawer) {
    patchState({ sidenav: drawer });
  }

  @Action(InstallApp)
  installApp({ getState, patchState }: StateContext<UI>) {
    const { install } = getState();
    if (install !== undefined) {
      install.prompt();
      const choiceResult = install.userChoice;
      if (choiceResult.outcome === "dismissed") {
        console.log("User cancelled home screen install");
      } else {
        console.log("User added to home screen");
      }
      patchState({ install: null });
    }
  }

  @Action(Loader)
  Loader({ patchState }: StateContext<UI>, { LoaderState }: Loader) {
    patchState({ LoaderState });
  }

  @Action(Vibrate)
  Vibrate({ duration }: Vibrate) {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(duration);
    }
  }
}
